import React from 'react';
import { Download, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { argentinaToday, useOtpCommissionExport } from '../hooks/useOtpCommissionExport';

export const OtpCommissionExportDialog = ({ operation, name, cvuId, onClose }) => {
  const { dates, changeDate, download, loading, error, downloaded } = useOtpCommissionExport({ operation, cvuId });
  return (
    <Dialog open onOpenChange={open => { if (!open) onClose(); }}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-lg max-h-[90dvh] overflow-y-auto rounded-lg"
        data-testid="otp-commission-export-dialog" data-close-testid="otp-commission-export-close">
        <DialogHeader className="text-left pr-5">
          <DialogTitle className="text-lg tracking-normal" data-testid="otp-commission-export-title">Exportar comisiones</DialogTitle>
          <DialogDescription data-testid="otp-commission-export-operation">{name}</DialogDescription>
        </DialogHeader>
        <form onSubmit={download} className="space-y-4" data-testid="otp-commission-export-form" aria-busy={loading}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {['desde', 'hasta'].map(key => (
              <label key={key} className="flex min-w-0 flex-col gap-1 text-sm font-medium" htmlFor={`otp-export-${key}`}>
                {key === 'desde' ? 'Desde' : 'Hasta'} · Argentina
                <input id={`otp-export-${key}`} type="date" required value={dates[key]} max={argentinaToday()} disabled={loading}
                  onChange={event => changeDate(key, event.target.value)}
                  data-testid={`otp-commission-export-${key}`}
                  className="w-full min-w-0 rounded border border-gray-300 dark:border-gray-600 px-3 py-2 bg-white dark:bg-gray-800 disabled:opacity-50" />
              </label>
            ))}
          </div>
          <div className="space-y-2 border-y border-gray-200 dark:border-gray-700 py-3 text-sm">
            <p data-testid="otp-commission-export-ledger">Resumen y Detalle: total al 2,5%, ya cobrado y falta por pagar.</p>
            <p className="text-amber-800 dark:text-amber-300" data-testid="otp-commission-export-warning">Pendiente estimado, sin descontar pagos de cierres semanales.</p>
          </div>
          {error && <p role="alert" className="text-sm text-red-600 break-words" data-testid="otp-commission-export-error">{error}</p>}
          {downloaded && <p role="status" className="text-sm text-emerald-700 dark:text-emerald-300" data-testid="otp-commission-export-success">Excel descargado.</p>}
          <div className="flex flex-wrap items-center justify-end gap-2">
            <button type="button" onClick={onClose} data-testid="otp-commission-export-cancel"
              className="rounded border border-gray-300 dark:border-gray-600 px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">Cerrar</button>
            <button type="submit" disabled={loading || !dates.desde || !dates.hasta} data-testid="otp-commission-export-download"
              className="inline-flex items-center justify-center gap-2 rounded bg-emerald-700 text-white hover:bg-emerald-800 px-3 py-2 text-sm disabled:opacity-50 transition-colors">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
              {loading ? 'Generando…' : 'Descargar Excel'}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};